import React from "react";
import { useLocation } from "react-router-dom";

import AuthFlowLayout from "../../layouts/AuthFlowLayout";
import BrandAuthLayout from "../../layouts/BrandAuthLayout";
import NewPasswordForm from "./components/NewPasswordForm";
import RedesignedNewPasswordForm from "./components/RedesignedNewPasswordForm/RedesignedNewPasswordForm";
import RedesignedResetPasswordForm from "./components/RedesignedResetPasswordForm/RedesignedResetPasswordForm";
import ResetPasswordForm from "./components/ResetPasswordForm";

const useNewDesign = process.env.REACT_APP_FEATURE_NEW_DESIGN === "true";

const ForgotPasswordPage = () => {
  const location = useLocation();

  const { userName } = Object.fromEntries(new URLSearchParams(location.search));

  if (useNewDesign) {
    return (
      <BrandAuthLayout
        heading="Reset Your Password"
        description="Enter your username and we'll send you a code to reset your password."
      >
        {userName ? <RedesignedNewPasswordForm userName={userName} /> : <RedesignedResetPasswordForm />}
      </BrandAuthLayout>
    );
  }

  return (
    <AuthFlowLayout
      heading="Join BrandGen.io"
      description="Create account: to view your personalized dashboard, campaigns, and audiences."
    >
      {userName ? <NewPasswordForm userName={userName} /> : <ResetPasswordForm />}
    </AuthFlowLayout>
  );
};

export default ForgotPasswordPage;
